import React from "react"
import {Container} from "reactstrap";
import {Themed} from '@/theme'
import PromoBannerModal from '@/shared/components/modal/PromoBannerModal.jsx';

const ParticipantTopbar = () => {
  return (
    <div className="topbar">
      <Container fluid className="topbar__wrapper">
        <Themed component={'Navbar'} />
        <PromoBannerModal />
      </Container>
    </div>
  )
}
export default ParticipantTopbar;
